import {
  UserLogin,
} from '@api/auth.service'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'
import sendCustomerData from '@/js/analytics/customer'

export default {
  name: 'Login',
  mixins: [FormMixin],
  props: ['info'],
  data() {
    return {
      accept_rules: false,
      offer: window.offer,
      rules: window.rules,
      non_field_errors: '',
      load: false,
      form: {
        username: '',
        password: '',
      },
      fields: [
        {
          size: '12',
          title: this._('Е-mail или номер телефон'),
          rules: 'required|email_phone',
          type: 'text',
          name: 'username',
          tag: 'd-control-input',
          props: {
            autofocus: 'true',
          },
        },
        {
          size: '12',
          title: this._('Пароль'),
          rules: 'required',
          type: 'password',
          name: 'password',
          tag: 'd-control-input',
        },
      ],
    }
  },
  methods: {
    async prepareData() {
      this.non_field_errors = ''
      this.$refs.validator.validate().then(valid => {
        if (!valid) return
        this.load = true
        this.form.username = this.form.username.toLowerCase()
        this.submit(valid, this.form)
      })
    },
    async send(data) {
      return UserLogin.execute({}, data)
        .then(async ({ data: { redirect: { location }, user } }) => {
          this.load = true
          // AnswerMessage(resData, this)
          await sendCustomerData(user)
          if (this.info.seller) {
            window.location.href = location
            return
          }
          window.location.reload()
          this.$emit('close')
          this.$refs.validator.reset()
          this.load = false
        })
    },
    updateValidator(errors) {
      this.load = false
      const parsed = defaultValidatorErrorsParser(errors)
      console.log(parsed);
      this.non_field_errors = parsed.non_field_errors
      this.$refs.validator.setErrors(parsed)
    },
  },
}
